import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommonBaseState, initialCommonBaseState } from "../../interfaces/redux/common";
import { logoutReducers, resetErrors, setError } from "../common/commonActions";
import { RootState } from "../store";
import { ignorePrice, loadEventWinItem, setLoading, setReloading, suspendEP, updateBettingState } from "./winActions";
import { Win } from "../../interfaces/dtos/win";

export interface WinState extends CommonBaseState {
    reloading: boolean;
    suspending: boolean;

    eventWins: Win[];
}

const initialState: WinState = {
    ...initialCommonBaseState,
    reloading: false,
    suspending: false,

    eventWins: [],
};

export const winSlice = createSlice({
    name: 'win',
    initialState,
    reducers: {
        errorOccured: (state, action: PayloadAction<string>) => {
            state.error = true;
            state.errorMessage = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // loadEventWinItem
            .addCase(loadEventWinItem.fulfilled, (state, action: PayloadAction<Win[]>) => {
                state.eventWins = action.payload;
            })
            .addCase(loadEventWinItem.rejected, (state, action) => {
                if (action.error.message?.indexOf("404") === -1) {
                    state.error = true;
                    state.errorMessage = `Could not load win:\r\n${action.error.message}`;
                }
            })

            // suspendEP
            .addCase(suspendEP.pending, (state) => {
                state.suspending = true;
                state.saving = true;
            })
            .addCase(suspendEP.fulfilled, (state) => {
                state.suspending = false;
                state.saving = false;
            })
            .addCase(suspendEP.rejected, (state, action) => {
                state.suspending = false;
                state.saving = false;
                state.error = true;
                state.errorMessage = `Could not suspend early prices:\r\n${action.error.message}`;
            })

            // updateBettingState
            .addCase(updateBettingState.pending, (state) => {
                state.saving = true;
            })
            .addCase(updateBettingState.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(updateBettingState.rejected, (state, action) => {
                state.saving = false;
                state.error = true;
                state.errorMessage = `Could not update betting state:\r\n${action.error.message}`;
            })

            // ignorePrice
            .addCase(ignorePrice.pending, (state) => {
                state.saving = true;
            })
            .addCase(ignorePrice.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(ignorePrice.rejected, (state, action) => {
                state.saving = false;
                state.error = true;
                state.errorMessage = `Could not ignore prices:\r\n${action.error.message}`;
            })

            // Set loading
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loading = action.payload;
            })

            // Set reloading
            .addCase(setReloading.fulfilled, (state, action) => {
                state.reloading = action.payload;
            })

            // Set error
            .addCase(setError.fulfilled, (state, action) => {
                state.error = true;
                state.errorMessage = action.payload;
            })
            // Reset feedback
            .addCase(resetErrors.fulfilled, (state) => {
                state.error = false;
            })
            // Logout
            .addCase(logoutReducers.fulfilled, () => {
                return initialState;
            });
    }
});

export const { errorOccured } = winSlice.actions;
export const winState = (state: RootState) => state.win;
export default winSlice.reducer;
